import { StatusCodes } from "http-status-codes";
import { getErrorPageForErrorCode } from "../config/Config";

let appErrorHandler;

export function setErrorHandler(someFn) {
  appErrorHandler = someFn;
}

function request(
  url,
  params = {},
  method,
  withCredentials = true,
  ignoreRedirect = false,
  ignoreJson = false,
  signal = null,
  retryCount = 1
) {
  let options = { method: method };
  let urlWithParams = url;
  if (signal) {
    options.signal = signal;
  }
  if (withCredentials) {
    options.credentials = "include";
  }
  if ("GET" === method) {
    if (!!params && Object.keys(params).length > 0) {
      urlWithParams += "?" + new URLSearchParams(params).toString();
    }
  } else {
    options.body = params instanceof FormData ? params : JSON.stringify(params);
  }

  return fetch(urlWithParams, options)
    .then((res) => {
      if (res.ok) {
        return ignoreJson ? res : res.json();
      }
      return Promise.reject(res);
    })
    .catch((res) => {
      if (window["ddlDebug"]) {
        console.error("Fetch error: ", res);
      }
      const status =
        res instanceof Response ? res.status : StatusCodes.BAD_GATEWAY;
      if (
        appErrorHandler &&
        (status === StatusCodes.UNAUTHORIZED ||
          status === StatusCodes.NOT_FOUND)
      ) {
        if (ignoreRedirect) {
          return Promise.reject(res);
        }
        const errorPage = getErrorPageForErrorCode(status);
        if (window.location.href.endsWith(errorPage)) {
          // already on the error page, no need to redirect
        } else {
          appErrorHandler(errorPage);
        }
        return;
      }
      // Retry ONCE on 504 Gateway Timeout for GET requests
      if (
        (status === StatusCodes.GATEWAY_TIMEOUT ||
          !(res instanceof Response)) &&
        method === "GET" &&
        retryCount > 0
      ) {
        return request(
          url,
          params,
          method,
          withCredentials,
          ignoreRedirect,
          ignoreJson,
          signal,
          retryCount - 1
        );
      }
      return Promise.reject(res);
    });
}

export function getRequest(url, params, ignoreRedirect = false, signal = null) {
  return request(url, params, "GET", true, ignoreRedirect, false, signal);
}

export function postRequest(
  url,
  body,
  withCredentials = true,
  ignoreRedirect = false,
  ignoreJson = false
) {
  return request(
    url,
    body,
    "POST",
    withCredentials,
    ignoreRedirect,
    ignoreJson
  );
}

export function putRequest(
  url,
  body,
  withCredentials = true,
  ignoreRedirect = false
) {
  return request(url, body, "PUT", withCredentials, ignoreRedirect);
}

export function patchRequest(
  url,
  body,
  withCredentials = true,
  ignoreRedirect = false
) {
  return request(url, body, "PATCH", withCredentials, ignoreRedirect);
}

export function deleteRequest(url, params) {
  return request(url, params, "DELETE");
}
